export function buildSuggestedAction(title, data) {
    const action = {
        title,
        type: 'postBack',
        value: data
    };
    return action;
}
export function pickBFFCardActionData(action, type) {
    if (action != null) {
        const payload = action.value || action.data;
        if (payload != null && payload.type) {
            if (!type || payload.type === type) {
                return payload;
            }
        }
    }
}
//# sourceMappingURL=bff-card-actions.js.map